import { z } from "zod";

import { defaultUrl, urlSchema } from "../shared";
import { customFieldSchema } from "./custom";

// Schema
export const basicsSchema = z.object({
  name: z.string(),
  headline: z.string(),
  email: z.literal("").or(z.string().email()).optional(),
  phone: z.string(),
  location: z.string(),
  url: urlSchema,
  customFields: z.array(customFieldSchema),
  // Additional personal fields
  dateOfBirth: z.string().optional(),
  idNumber: z.string().optional(),
  nationality: z.string().optional(),
  maritalStatus: z.string().optional(),
  picture: z.object({
    url: z.string(),
    size: z.number().default(64),
    aspectRatio: z.number().default(1),
    borderRadius: z.number().default(0),
    effects: z.object({
      hidden: z.boolean().default(false),
      border: z.boolean().default(false),
      grayscale: z.boolean().default(false),
    }),
  }),
});

// Type
export type Basics = z.infer<typeof basicsSchema>;

// Defaults
export const defaultBasics: Basics = {
  name: "Your Name",
  headline: "",
  phone: "(123) 456-7890",
  location: "New York, US",
  url: defaultUrl,
  customFields: [],
  dateOfBirth: "", 
  idNumber: "",
  nationality: "",
  maritalStatus: "",
  picture: {
    url: "/images/default-profile.jpg",
    size: 64,
    aspectRatio: 1, 
    borderRadius: 0,
    effects: {
      hidden: false,
      border: false,
      grayscale: false,
    },
  },
};

export * from "./custom";
